module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lhsx"
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 0px 30px 20px"
    }
  }, [_c('img', {
    ref: "topLogo",
    attrs: {
      "src": require("./logo.png"),
      "width": "40%",
      "height": "30%",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    ref: "topLogo",
    attrs: {
      "src": require("./txgg_top.png"),
      "width": "82%",
      "height": "40%",
      "alt": ""
    }
  })]), _vm._v(" "), (!_vm.showSuccess) ? _c('div', {
    attrs: {
      "id": "form"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.clientName),
      expression: "formData.clientName"
    }],
    staticClass: "name",
    attrs: {
      "type": "text",
      "placeholder": "请输入真实姓名"
    },
    domProps: {
      "value": (_vm.formData.clientName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.clientName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.clientMobile),
      expression: "formData.clientMobile"
    }],
    staticClass: "clientMobile",
    attrs: {
      "type": "tel",
      "placeholder": "请输入手机号码",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.formData.clientMobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.clientMobile = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.code),
      expression: "formData.code"
    }],
    staticClass: "code",
    attrs: {
      "type": "tel",
      "placeholder": "请输入验证码",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.formData.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "send",
    class: {
      disable: this.verifyMsg !== '获取验证码'
    },
    on: {
      "click": _vm.sendCode
    }
  }, [_vm._v(_vm._s(_vm.verifyMsg))]), _vm._v(" "), _c('div', {
    staticClass: "ystk"
  }, [_c('van-checkbox', {
    attrs: {
      "icon-size": "14px",
      "checked-color": "#ffc500"
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_c('span', [_vm._v("已阅读并同意")])]), _c('span', {
    on: {
      "click": _vm.ystkShow
    }
  }, [_vm._v("《个人信息与隐私保护条款》")])], 1), _vm._v(" "), _c('div', {
    staticClass: "coloryellow"
  }, [_vm._v("\n      提交成功后，工作人员会尽快与您联系。\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./1-5.png"),
      "alt": "",
      "height": "40px"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.showSuccess) ? _c('img', {
    staticStyle: {
      "margin": "20px 0 30px 0"
    },
    attrs: {
      "id": "isSuccess",
      "src": require("./2.png"),
      "width": "100%",
      "height": "40%",
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./txgg_zbfl.png"),
      "width": "100%",
      "height": "82%",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "topdiv wechatImg"
  }, [_c('img', {
    attrs: {
      "src": require("./button.png"),
      "width": "88%",
      "height": "100%",
      "alt": ""
    },
    on: {
      "click": _vm.showWechatOverlayHandle
    }
  })]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./txgg_khzb.png"),
      "width": "100%",
      "height": "82%",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "padsding": "20px 0"
    },
    attrs: {
      "src": require("./4.png"),
      "width": "100%",
      "height": "54%",
      "alt": ""
    }
  }), _vm._v(" "), (!_vm.showSuccess) ? _c('div', {
    staticClass: "topdiv",
    on: {
      "click": function($event) {
        _vm.backTop()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./1-5.png"),
      "alt": "",
      "height": "40px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./5-1.png"),
      "width": "100%",
      "height": "3%",
      "alt": ""
    }
  }), _vm._v(" "), _c('alert', {
    attrs: {
      "showModal": _vm.showAlert
    },
    on: {
      "update:showModal": function($event) {
        _vm.showAlert = $event
      }
    }
  }, [_vm._v(_vm._s(_vm.alertMessage))]), _vm._v(" "), _c('van-overlay', {
    attrs: {
      "show": _vm.showOverlay,
      "lock-scroll": false
    },
    on: {
      "click": function($event) {
        _vm.showOverlay = false
      }
    }
  }, [_c('div', {
    staticClass: "wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('ystk', {
    on: {
      "close": _vm.close
    }
  })], 1)]), _vm._v(" "), _c('van-overlay', {
    attrs: {
      "show": _vm.showWechatOverlay,
      "lock-scroll": false
    },
    on: {
      "click": function($event) {
        _vm.showWechatOverlay = false
      }
    }
  }, [_c('div', {
    staticClass: "wechatWrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./wechat.png"),
      "width": "80%",
      "height": "80%",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px",
      "color": "#ffffff",
      "text-align": "center"
    }
  }, [_vm._v("长按识别二维码或保存图片使用微信扫码关注")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./close.png"),
      "width": "50px",
      "height": "50px",
      "alt": ""
    },
    on: {
      "click": _vm.closeWechatOverlayHandle
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-272c3ac4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/bdyxgg/index.vue
// module id = 872
// module chunks = 2